import React from "react";
import { Link } from "react-router-dom";
import "./Contact.css";
import Seo from "../components/Seo";

const contactMethods = [
  {
    icon: "bi bi-telephone",
    label: "Toll-Free Support",
    value: "---------------",
    href: "tel:18002104422",
  },
  {
    icon: "bi bi-telephone-inbound",
    label: "Office Number",
    value: "-------------",
    href: "tel:+912079637941",
  },
  {
    icon: "bi bi-envelope",
    label: "General Enquiry",
    value: "contact@monayra.com",
    href: "mailto:contact@monyara.com",
  },
  {
    icon: "bi bi-headset",
    label: "Customer Support",
    value: "support@monayra.com",
    href: "mailto:support@monayra.com",
  },
];

const socialLinks = [
  {
    icon: "bi bi-facebook",
    label: "Facebook",
    href: "",
  },
  {
    icon: "bi bi-linkedin",
    label: "LinkedIn",
    href: "",
  },
  {
    icon: "bi bi-instagram",
    label: "Instagram",
    href: "",
  },
  {
    icon: "bi bi-youtube",
    label: "YouTube",
    href: "",
  },
];

const Contact = () => {
  return (
    <>
      <Seo
        title="Contact MONAYRA | Loan Assistance in Pune"
        description="Contact MONAYRA (OPC) PRIVATE LIMITED for assistance with home loans, business loans, Loan Against Property, car loans and other financial services."
        keywords="contact MONAYRA, loan assistance Pune, home loan support Pune, business loan enquiry, Loan Against Property help"
        canonical="https://www.monayra.com/contact"
      />

      <main className="monayra-contact-page">
        <section className="contact-page-hero">
          <div className="contact-page-hero-overlay"></div>

          <div
            className="contact-page-glow contact-page-glow-left"
            aria-hidden="true"
          ></div>

          <div
            className="contact-page-glow contact-page-glow-right"
            aria-hidden="true"
          ></div>

          <div className="contact-page-container contact-page-hero-grid">
            <div className="contact-page-hero-content">
              <span className="contact-page-eyebrow">
                Contact MONAYRA
              </span>

              <h1>
                Speak with a loan expert who
                <span> understands your requirement</span>
              </h1>

              <p>
                Connect with MONAYRA (OPC) PRIVATE LIMITED for professional
                assistance with home loans, Loan Against Property, business
                loans, personal loans, car loans and education loans.
              </p>

              <div className="contact-page-hero-actions">
                <a
                  href="tel:18002104422"
                  className="contact-page-primary-btn"
                >
                  <i className="bi bi-telephone"></i>
                  Call 1800 210 4422
                </a>

                <Link
                  to="/apply-now"
                  className="contact-page-secondary-btn"
                >
                  <i className="bi bi-file-earmark-text"></i>
                  Apply Online
                </Link>
              </div>

              <div className="contact-page-hero-features">
                <div>
                  <i className="bi bi-headset"></i>
                  Professional assistance
                </div>

                <div>
                  <i className="bi bi-file-earmark-check"></i>
                  Document guidance
                </div>

                <div>
                  <i className="bi bi-bank"></i>
                  Multiple lender options
                </div>
              </div>
            </div>

            <div className="contact-page-hero-card">
              <span className="contact-page-hero-card-icon">
                <i className="bi bi-chat-dots"></i>
              </span>

              <span className="contact-page-card-eyebrow">
                Need Loan Assistance?
              </span>

              <h2>Let our team guide you</h2>

              <p>
                Share your loan type, required amount, income profile and city.
                Our team will help you understand suitable next steps.
              </p>

              <div className="contact-page-mini-list">
                <div>
                  <i className="bi bi-check-circle"></i>
                  Eligibility guidance
                </div>

                <div>
                  <i className="bi bi-check-circle"></i>
                  Lender comparison
                </div>

                <div>
                  <i className="bi bi-check-circle"></i>
                  Documentation support
                </div>
              </div>

              <Link
                to="/apply-now"
                className="contact-page-primary-btn"
              >
                Submit Your Requirement
                <i className="bi bi-arrow-right"></i>
              </Link>
            </div>
          </div>
        </section>

        <section className="contact-page-details-section">
          <div className="contact-page-container">
            <div className="contact-page-section-header">
              <span className="contact-page-eyebrow">
                Get in Touch
              </span>

              <h2>
                Choose the most convenient way to
                <span> connect with us</span>
              </h2>

              <p>
                Call, email or visit our office for assistance with your loan
                enquiry.
              </p>
            </div>

            <div className="contact-page-methods-grid">
              {contactMethods.map((method) => (
                <a
                  href={method.href}
                  className="contact-page-method-card"
                  key={method.label}
                >
                  <span className="contact-page-method-icon">
                    <i className={method.icon}></i>
                  </span>

                  <div>
                    <small>{method.label}</small>
                    <strong>{method.value}</strong>
                  </div>

                  <i className="bi bi-arrow-up-right"></i>
                </a>
              ))}
            </div>
          </div>
        </section>

        <section className="contact-page-location-section">
          <div className="contact-page-container contact-page-location-grid">
            <div className="contact-page-address-card">
              <span className="contact-page-address-icon">
                <i className="bi bi-geo-alt-fill"></i>
              </span>

              <span className="contact-page-card-eyebrow">
                Visit Our Office
              </span>

              <h2>MONAYRA (OPC) PRIVATE LIMITED</h2>

              <address>
                Near FC Road
                <br />
                Pune – 411028
                <br />
                Maharashtra, India
              </address>

              <div className="contact-page-office-info">
                <div>
                  <i className="bi bi-clock"></i>

                  <span>
                    <small>Office Hours</small>
                    <strong>Monday to Saturday</strong>
                  </span>
                </div>

                <div>
                  <i className="bi bi-calendar-check"></i>

                  <span>
                    <small>Consultation</small>
                    <strong>Prior appointment recommended</strong>
                  </span>
                </div>
              </div>

              <a
                href="https://www.google.com/maps/search/?api=1&query=Mahadik+House+Bhosale+Nagar+Hadapsar+Pune"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-page-map-btn"
              >
                <i className="bi bi-signpost-2"></i>
                Get Directions
              </a>
            </div>

            <div className="contact-page-map-card">
              <iframe
                src=""
                title="MONAYRA office location"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              ></iframe>

              <div className="contact-page-map-overlay">
                <span>
                  <i className="bi bi-geo-alt"></i>
                </span>

                <div>
                  <strong>Hadapsar, Pune</strong>
                  <small>Office location</small>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="contact-page-consultation-section">
          <div className="contact-page-container contact-page-consultation-grid">
            <div className="contact-page-consultation-content">
              <span className="contact-page-eyebrow">
                Book a Consultation
              </span>

              <h2>
                Discuss your loan requirement with
                <span> our relationship team</span>
              </h2>

              <p>
                Schedule a consultation to discuss eligibility, documents,
                lender options and the expected loan process.
              </p>

              <div className="contact-page-consultation-points">
                <div>
                  <span>
                    <i className="bi bi-person-check"></i>
                  </span>

                  <div>
                    <strong>Profile Review</strong>
                    <small>
                      Discuss your income, obligations and required loan
                      amount.
                    </small>
                  </div>
                </div>

                <div>
                  <span>
                    <i className="bi bi-bank"></i>
                  </span>

                  <div>
                    <strong>Lender Guidance</strong>
                    <small>
                      Understand potentially suitable bank and financial
                      institution options.
                    </small>
                  </div>
                </div>

                <div>
                  <span>
                    <i className="bi bi-folder-check"></i>
                  </span>

                  <div>
                    <strong>Document Checklist</strong>
                    <small>
                      Receive guidance on the documents generally required.
                    </small>
                  </div>
                </div>
              </div>
            </div>

            <aside className="contact-page-appointment-card">
              <span className="contact-page-appointment-icon">
                <i className="bi bi-calendar2-check"></i>
              </span>

              <span className="contact-page-card-eyebrow">
                Schedule Assistance
              </span>

              <h3>Speak with our team today</h3>

              <p>
                Call us directly or submit your enquiry online. Our team will
                connect with you regarding the next steps.
              </p>

              <a
                href="tel:18002104422"
                className="contact-page-primary-btn"
              >
                <i className="bi bi-telephone"></i>
                Call Now
              </a>

              <Link
                to="/apply-now"
                className="contact-page-secondary-btn"
              >
                <i className="bi bi-file-earmark-text"></i>
                Submit Enquiry
              </Link>
            </aside>
          </div>
        </section>

        <section className="contact-page-social-section">
          <div className="contact-page-container">
            <div className="contact-page-social-card">
              <div>
                <span className="contact-page-eyebrow">
                  Follow MONAYRA
                </span>

                <h2>Connect with us on social media</h2>

                <p>
                  Follow our social channels for loan information, financial
                  guidance and company updates.
                </p>
              </div>

              <div className="contact-page-social-links">
                {socialLinks.map((social) => (
                  <a
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Visit MONAYRA on ${social.label}`}
                    key={social.label}
                  >
                    <i className={social.icon}></i>
                    <span>{social.label}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="contact-page-disclaimer">
          <div className="contact-page-container">
            <i className="bi bi-info-circle"></i>

            <p>
              MONAYRA (OPC) PRIVATE LIMITED provides loan assistance and
              facilitates applications with selected lending institutions.
              Final approval, interest rates, loan amount, tenure and charges
              are determined by the lender based on its policies and the
              applicant’s eligibility.
            </p>
          </div>
        </section>
      </main>
    </>
  );
};

export default Contact;